import React, { useEffect, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/basicInfo/currencyValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { CurrencyContext } from "../currency";

axios.defaults.baseURL = API;

function UpdateCurrency(props) {

    const {dataList, setDataList, data} = useContext(CurrencyContext);

    const handleInputStatusChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.Currency.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckCurrency", results[0].Currency);
        else
            handleChange("CheckCurrency", "");
    }

    async function update() {
        let token = localStorage.getItem("token");
        var data = {
            Currency: values.Currency
        }
        await axios.put(`/updateCurrency/${values.CurrencyID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {

            for (var i=0; i < dataList.length; i++) {
                if (dataList[i].CurrencyID == values.CurrencyID) {
                    dataList[i].Currency = values.Currency;
                    localStorage.setItem("currencyData", JSON.stringify(dataList));
                    break;
                }
            }  
            setDataList(dataList);
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    const ClearData = () => {
        handleChange("CurrencyID", "");
        handleChange("Currency", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(update, validate);

    useEffect(() => {
        data.forEach(value => {
            handleChange("CurrencyID", value.CurrencyID);
            handleChange("Currency", value.Currency);
            handleChange("CheckCurrency", "");
        });
    }, [data]);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="popUpcontent">
                <div className="popUpHeader">
                    <span>ແກ້ໄຂສະກຸນເງິນ</span>
                </div>
                <div className="popUpBody">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="form-group">
                                <span>ສະກຸນເງິນ</span>
                                <input className={`input form-control ${errors.Currency && 'is-invalid'}`} type="text" name="Currency" onChange={(e) => handleInputStatusChange(e)} value={values.Currency || ''} required />
                                {errors.Currency && (
                                    <p className="invalid-feedback">{errors.Currency}</p>
                                )}
                            </div>
                        </div>
                        <div className="popUpfooter">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateCurrency;
